import { getConfig } from './config';

export { getConfig };

export const REGISTRATION_TYPE = {
  TRIAL: 'trial',
  PER_SESSION: 'per_session',
  PER_MONTH: 'per_month',
};

function countSessions(month, sessions) {
  const matchingSessions = sessions
    .filter((session) => {
      return session.date.getUTCMonth() === month.date.getUTCMonth();
    })
    .filter((session) => !session.full);

  return matchingSessions.length;
}

export function getSessions(month, sessions) {
  const matchingSessions = sessions
    .filter((session) => {
      return session.date.getUTCMonth() === month.date.getUTCMonth();
    })
    .filter((session) => !session.full);

  return matchingSessions;
}

export function getPaymentSummary(config, ctx) {
  const { type, settings } = config;

  if (type === 'event') {
    const { events } = config;
    const { selectedEvents } = ctx;

    const selection = events.filter((e) => selectedEvents.indexOf(e.code) >= 0);

    let discount = 0;
    if (settings.discount_min_2 && selection.length >= 2) {
      discount = settings.discount_min_2;
    }
    if (settings.discount_min_3 && selection.length >= 3) {
      discount = settings.discount_min_3;
    }

    return {
      events: selection,
      totalEvents: selection.length,
      totalPrice:
        selection.reduce(
          (previousValue, currentValue) => previousValue + currentValue.price,
          0
        ) - discount,
      totalDiscount: discount,
    };
  }

  if (type === 'session') {
    const { sessions } = config;
    const { registrationType, selection } = ctx;
    if (registrationType === REGISTRATION_TYPE.TRIAL) {
      return {
        sessions: selection,
        totalSessions: selection.length,
        totalPrice: selection.length * settings.trial_price,
      };
    }

    if (registrationType === REGISTRATION_TYPE.PER_SESSION) {
      const pricePerSession =
        selection.length >= settings.discount_min_sessions
          ? settings.discounted_session_price
          : settings.session_price;

      return {
        sessions: selection,
        totalSessions: selection.length,
        totalPrice: selection.length * pricePerSession,
      };
    }

    if (registrationType === REGISTRATION_TYPE.PER_MONTH) {
      const totalSessions = selection
        .map((month) => countSessions(month, sessions))
        .reduce((a, b) => a + b, 0);

      const pricePerSession =
        selection.length >= settings.discount_min_months
          ? settings.discounted_month_session_price
          : settings.session_price;

      return {
        months: selection,
        sessions: selection
          .map((month) => getSessions(month, sessions))
          .reduce((arr, session) => {
            arr.push(...session);
            return arr;
          }, []),
        totalMonths: selection.length,
        totalSessions,
        totalPrice: totalSessions * pricePerSession,
      };
    }
  }
}
